import changelog from '../../CHANGELOG.md';

'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:ChangeLogCtrl
 * @description
 * # ProjectIndexCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.controllers')
.controller('ChangeLogCtrl', ['$scope', '$sce', function($scope, $sce) {
  let showdown = window.showdown;
  let converter = new showdown.Converter();

  let html = converter.makeHtml(changelog);
  $scope.htmlSafe = $sce.trustAsHtml(html);
}]);
